/**
 * @namespace toolkit.enums
 */
 
 /**
 * @class toolkit.enums.EditorState
 * @classdesc States of editor.
 */
export enum EditorState {

    /**
     * The add state.
     * @member {number} toolkit.enums.EditorState#Add
     */  
    Add,

    /**
     * The edit state.
     * @member {number} toolkit.enums.EditorState#Edit
     */  
    Edit
}



// WEBPACK FOOTER //
// ./src/enums/editorState.ts